module.exports = __webpack_public_path__ + "img/ER.641b8880.svg";